// extracted by mini-css-extract-plugin
export default {"linksContainer":"HW8_MZqJzWTMIwS1tHHN__linksContainer___","signInLink":"b_ESVcWY1mS2IAFU2gOg__signInLink___","signUpButton":"bv0AHimzVMCeuEzUosUS__signUpButton___"};